import { TextField } from '@mui/material';
import React from 'react';

import { PartActionSelection } from './MobilePartActionsDialog.props';
import {
  ConfirmContent,
  ErrorMessage,
  SelectedActionBadge,
  NotesSection,
} from './MobilePartActionsDialog.styles';
import { InteractionFormData, ServiceObject } from '../../../../../../@types/service.type';
import { MobileInteractionForm } from '../MobileStatusUpdateDialog/MobileInteractionForm';

interface PartActionInteractionStepProps {
  selectedAction: PartActionSelection;
  notes: string;
  onNotesChange: (value: string) => void;
  error: string | null;
  interactions: InteractionFormData[];
  formValues: Record<string, unknown>;
  onFieldChange: (interactionId: number, fieldId: number, value: unknown) => void;
  onBlockBypass?: (interactionId: number, fieldId: number) => void;
  isBlocked: boolean;
  service?: ServiceObject;
}

export const PartActionInteractionStep: React.FC<PartActionInteractionStepProps> = ({
  selectedAction,
  notes,
  onNotesChange,
  error,
  interactions,
  formValues,
  onFieldChange,
  onBlockBypass,
  service,
}) => {
  return (
    <ConfirmContent>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <SelectedActionBadge>{selectedAction.name}</SelectedActionBadge>

      {interactions.map((interaction) => (
        <MobileInteractionForm
          key={interaction.id}
          interaction={interaction}
          formValues={formValues}
          onFieldChange={onFieldChange}
          onBlockBypass={onBlockBypass}
          service={service}
        />
      ))}

      <NotesSection>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Notes (optional)"
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          size="small"
        />
      </NotesSection>
    </ConfirmContent>
  );
};
